@if (isLoading) {
  <div class="state-container">
    <div class="spinner-border text-danger" role="status"></div>
  </div>
} @else {
  <div class="part-details-layout" *transloco="let t; prefix: 'parts.modals'">
    <section class="part-details-card">
      <div class="part-details-card__header">
        <h3>{{ t('partDetails.title') }}</h3>

        <div class="part-details-card__actions">
          <button type="button" class="icon-action-btn" (click)="openEditPart()" [attr.aria-label]="t('partDetails.editAria')">
            <i class="ph ph-pencil-simple"></i>
          </button>

        </div>
      </div>

      <div class="part-details-grid">
        <div class="detail-item">
          <span class="label">{{ t('fields.currentStock') }}</span>
          <p>{{ currentStock }}</p>
        </div>
        <div class="detail-item">
          <span class="label">{{ t('fields.category') }}</span>
          <p>{{ category }}</p>
        </div>

        <div class="detail-item">
          <span class="label">{{ t('fields.unitCost') }}</span>
          <p>{{ unitCost }}</p>
        </div>
        <div class="detail-item">
          <span class="label">{{ t('fields.reorderPoint') }}</span>
          <p>{{ reorderPoint }}</p>
        </div>

        <div class="detail-item">
          <span class="label">{{ t('fields.warranty') }}</span>
          <p>{{ warranty }}</p>
        </div>
        <div class="detail-item">
          <span class="label">{{ t('fields.reorderQuantity') }}</span>
          <p>{{ reorderQuantity }}</p>
        </div>

        <div class="detail-item">
          <span class="label">{{ t('fields.storageLocation') }}</span>
          <p>{{ storageLocation }}</p>
        </div>
        <div class="detail-item">
          <span class="label">{{ t('fields.maximumQuantity') }}</span>
          <p>{{ maximumQuantity }}</p>
        </div>
      </div>
    </section>

    <button
      type="button"
      class="reorder-toggle-row"
      [class.is-active]="isReorderNotificationEnabled"
      role="switch"
      [attr.aria-checked]="isReorderNotificationEnabled"
      [disabled]="isSavingReorderNotification" (click)="toggleReorderNotification()">
      <span class="fake-switch"></span>
      <span class="toggle-label">{{ t('partDetails.reorderNotification') }}</span>
    </button>
  </div>
}